import { useDeleteAccessKey } from '@api/accessKeys';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';
import { IRowActionDialogProps } from 'types/common';
import AccessKeyDeleteDialog from '../Helpers/AccessKeyDeleteDialog';

const DeleteDialog: React.FC<IRowActionDialogProps> = (props) => {
	const accessKeysMutation = useDeleteAccessKey();
	return (
		<AccessKeyDeleteDialog
			{...props}
			mutation={accessKeysMutation}
			accessKeyType={AccessKeyType.access}
		/>
	);
};

export default DeleteDialog;
